import { render, staticRenderFns } from "./Duel_Section_Header.vue?vue&type=template&id=1577dc40&scoped=true&"
import script from "./Duel_Section_Header.vue?vue&type=script&lang=js&"
export * from "./Duel_Section_Header.vue?vue&type=script&lang=js&"
import style0 from "./Duel_Section_Header.vue?vue&type=style&index=0&id=1577dc40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1577dc40",
  null
  
)

export default component.exports